<template>
    <div class="report-ci-wrapper">
        <loader
            class="loader"
            :class="[isEnhancedLayout ? 'enhanced' : 'classic']"
            v-if="!iframeLoaded"
        />
        <top-bar-secondary renderCI />
        <iframe
            ref="ciFrame"
            v-if="isEnhancedLayout"
            :src="iframeSrc + '?leftnav=1'"
            class="report-ci-enhanced"
            :class="{ 'iframe-loading': !iframeLoaded }"
            frameborder="0"
            @load="onIframeLoad"
        />
        <iframe
            ref="ciFrame"
            v-else
            :src="iframeSrc"
            class="report-ci-classic"
            :class="{ 'iframe-loading': !iframeLoaded }"
            frameborder="0"
            @load="onIframeLoad"
        />
    </div>
</template>

<script>
import loader from "@/module/commons/loader.vue";
import TopBarSecondary from "@/module/layout/top-bar-secondary.vue";

export default {
    name: "ReportCI",
    components: { loader, TopBarSecondary },
    data() {
        return {
            iframeLoaded: false
        };
    },
    computed: {
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        },
        iframeSrc() {
            return `${process.env.CI_APPS}report/report/view/${this.$route.params.id}?iframe=true&leftnav=true`;
        }
    },
    watch: {
        $route(newRoute) {
            /* When user accesses one Recent report to another,
               show loader to let user know that page change is taking place
             */
            if (newRoute.name === "report-ci") {
                this.iframeLoaded = false;
            }
        }
    },
    created() {
        this.$root.$on("layout-initialized", () => {
            this.validateEnhancedLayout();
        });
    },
    mounted() {
        if (this.$store.state.isLayoutInitialized) {
            this.validateEnhancedLayout();
        }

        window.addEventListener("message", this.onMessage);
    },
    beforeDestroy() {
        window.removeEventListener("message", this.onMessage);
        this.$root.$off("layout-initialized");
    },
    methods: {
        onIframeLoad() {
            this.iframeLoaded = true;
            const iframe = this.$refs.ciFrame;
            const doc = iframe.contentDocument || iframe.contentWindow.document;
            if (!doc) return;
            const script = doc.createElement("script");
            script.textContent = `
            document.body.addEventListener("click", function(e) {
                const a = e.target.closest("a");
                if (!a) return;
                
                const href = a.getAttribute("href");
                if (!href.includes("/view/")) return;

                e.preventDefault();

                // initially wanted to use regex but the patterns are not consistent, so it's better to use direct mapping
                const mapping = {
                    "client/client/view/": "/client/profile/",
                    "patient/patient/view/": "/patient/profile/",
                    "contact/contact/view/": "/contact/profile/",
                    "contact/company/view/": "/contact/company/",
                    "inventory/item/view/": "/inventory/item/",
                    "inventory/purchase_order/view/": "/inventory/purchase-order/",
                    "inventory/purchase_order_receipt/view/": "/inventory/receipt/",
                    "business/staff/view/": "/settings/users/view/",
                };

                const uid = href.split("/").pop();
                const path = Object.entries(mapping).find(([key]) => href.includes(key))?.[1] || "";

                if (!path || path === "") return; // stop if no mapping found
                window.parent.postMessage({ vueRoute: path + uid }, "*");
            });
            `;
            doc.head.appendChild(script);
        },
        onMessage(e) {
            if (e.data.vueRoute) {
                this.$router.push(e.data.vueRoute);
            }
        },
        validateEnhancedLayout() {
            // Force redirect user to classic view if not in enhanced view
            if (!this.isEnhancedLayout) {
                location.href =
                    process.env.APPS +
                    "index.php/report/report/view/" +
                    this.$route.params.id;
                return;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
$top-bar-primary-height: 64px;
$top-bar-ci-secondary-height: 46px;

.report-ci-wrapper {
    position: relative;
}
.loader {
    position: absolute;
    z-index: 100;

    &.classic {
        top: $top-bar-primary-height;
    }

    &.enhanced {
        top: $top-bar-ci-secondary-height;
    }
}

.report-ci-classic {
    width: 100%;
    height: 100vh;
    padding-top: 0;
    border: none;
}

.report-ci-enhanced {
    width: 100%;
    height: 100vh;
    padding-top: $top-bar-ci-secondary-height;
    border: none;
}

.iframe-loading {
    visibility: hidden;
}

@media screen and (min-width: 992px) {
    .report-ci-classic {
        padding-top: $top-bar-primary-height;
    }
}
</style>
